<template>
  <div>
    <div class="is-flex">
      <h1 class="title is-3">Csoportvezetői ellenőrzés</h1>
      <!--      <b-button class="ml-auto"-->
      <!--                type="is-primary">-->
      <!--        Összes hír olvasottnak jelölése-->
      <!--      </b-button>-->
    </div>
    <div>
      <b-table :data="inspectionReviewList"
               :loading="isLoading"
               class="mb-6"
               default-sort="date"
               default-sort-direction="asc"
               sticky-header
               :row-class="getRowClass"
               :paginated="(Array.isArray(inspectionReviewList) && inspectionReviewList.length > 20)"
               per-page="20"
               height="auto"
      >
        <h2 slot="empty">Jelenleg nincsen Önhöz rentelt ellenőrzés</h2>
        <b-table-column field="name"
                        label="Ellenőr"
                        width="300"
                        sortable
                        v-slot="props"
                        header-class="has-background-success has-text-white">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column field="ellenorzott_nev"
                        label="Ellenőrzés"
                        width="300"
                        sortable
                        v-slot="props"
                        header-class="has-background-success has-text-white">
          {{ props.row.ellenorzott_nev }}
        </b-table-column>
        <b-table-column field="membership_number"
                        label="Azonosító"
                        width="100"
                        sortable
                        v-slot="props"
                        header-class="has-background-success has-text-white">
          {{ props.row.membership_number }}
        </b-table-column>
        <b-table-column field="type"
                        label="Típus"
                        width="100"
                        sortable
                        v-slot="props"
                        header-class="has-background-success has-text-white">
          {{ arrayToString(props.row.type) }}
        </b-table-column>
        <b-table-column field="status_id"
                        label="Státusz"
                        width="100"
                        sortable
                        v-slot="props"
                        header-class="has-background-success has-text-white">
          <b-tag :type="getStatusClass(props.row.status_id)"
                 class="is-radiusless">
            {{ props.row.status_name }}
          </b-tag>
        </b-table-column>
        <b-table-column label="Műveletek"
                        width="120"
                        v-slot="props"
                        header-class="has-background-success has-text-white">
          <b-field>
            <b-button v-if="Number(props.row.status_id) >= 4 && $store.getters.minUserLevelGroupLeader"
                      type="is-primary"
                      class="is-radiusless"
                      size="is-small"
                      @click="redirectToInspection(props.row.ellenorzes_id, props.row.id, props.row.name)">
              Megnyitás
            </b-button>
          </b-field>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import { differenceInCalendarDays } from 'date-fns'
import { formattedDate, arrayToString, getInspectionStatusClass } from '@/utils/utils'

export default {
  name: 'InspectionReview',
  components: {},
  data () {
    return {
      isLoading: false,
      // inspectionReviewList: [],
    }
  },
  methods: {
    formattedDate,
    arrayToString,
    getStatusClass: getInspectionStatusClass,
    async redirectToInspection (inspectionID, inspectorID, inspectorName) {
      await this.$store.dispatch('setAliasUser', {
        userID: inspectorID,
        name: inspectorName,
      })
      console.log(1, inspectionID, inspectorID, inspectorName)
      await this.$router.push(`/Inspection/${inspectionID}/details`)
      console.log(2)
      // window.location.replace('/')
    },
    getRowClass (row, index) {
      let respClass =
        index % 2 === 0
          ? 'has-background-white' : 'has-background-green-light'
      if (this.$store.getters.isLawyer && Number(row.status_id) === 5 && !this.$store.getters.isAdmin) {
        // eslint-disable-next-line no-unused-vars
        const daysDiff = differenceInCalendarDays(new Date(row.deadline), new Date())
        if (daysDiff <= 5) {
          respClass = 'has-background-danger has-text-white'
        } else if (daysDiff <= 10) {
          respClass = 'has-background-warning'
        } else if (daysDiff <= 15) {
          respClass = 'has-background-info-light'
        }
      }

      return respClass
    },
  },
  computed: {
    inspectionReviewList () {
      return this.$store.state.inspectionReview.list
    },
  },
  async beforeCreate () {
    this.isLoading = true
    await this.$store.dispatch('fetchInspectionReviewList')
    this.isLoading = false
  },
}
</script>
